import { useQueryHelper } from '@anytag/shared-hooks';
import { getValuableVariables } from '@anytag/shared-utils';
import { EngagementTrafficSourceChart } from '@anytag/shared-molecules';
import { useEngagementCampaignTrafficSourceQuery } from '@anytag/graphql';
import { BaseModal, BaseModalProps, CircularProgress, ModalBody } from '@anytag/shared-atoms';
import { PostReportFilterFormValues } from '../../PostReport';

export interface EngagementCampaignTrafficSourceModalProps extends Pick<BaseModalProps, 'open' | 'onClose'> {
  campaignId: number;
  filter: PostReportFilterFormValues;
}

export const EngagementCampaignTrafficSourceModal = ({
  open,
  filter,
  onClose,
  campaignId
}: EngagementCampaignTrafficSourceModalProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { data, loading } = useEngagementCampaignTrafficSourceQuery({
    variables: getValuableVariables({ pk: campaignId, ...filter }),
    onCompleted: ({ engagementCampaignTrafficSource }) => {
      if (!engagementCampaignTrafficSource?.length) {
        onClose?.();
        enqueueSnackbar(t('Traffic source information was not found for this campaign'), { variant: 'info' });
      }
    },
    onError: (error) => {
      onClose?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  return (
    <BaseModal size="content" open={open} onClose={onClose} title={t('Total traffic source for this campaign')} asChild>
      <ModalBody className="pb-0">
        <div className="min-h-143.75">
          {loading ? (
            <div className="flex size-full min-h-[inherit] items-center justify-center">
              <CircularProgress size={64} thickness={1} className="bg-black-30" />
            </div>
          ) : (
            <EngagementTrafficSourceChart data={data?.engagementCampaignTrafficSource || []} />
          )}
        </div>
      </ModalBody>
    </BaseModal>
  );
};
